<template>
    <button
        :aria-disabled="disabled"
        :class="{
            'button-disabled': disabled,
            'button-loading': loading,
            'button-outlined': variant === 'outlined',
            'button-contained': variant === 'contained',
        }"
        class="button-root"
        tabindex="0"
        @click="handleClick"
        @keyup.enter="handleClick"
    >
        <div><slot></slot></div>
        <span v-if="loading">
            <svg viewBox="22 22 44 44">
                <circle class="button-loading-circle" cx="44" cy="44" r="20.2" fill="none" stroke-width="3.6" />
            </svg>
        </span>
    </button>
</template>

<script>
    export default {
        name: 'TextButton',
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            loading: {
                type: Boolean,
                default: undefined,
            },
            variant: {
                type: String,
                default: 'outlined',
            },
        },
        emits: ['click'],
        methods: {
            handleClick() {
                if (!this.disabled && !this.loading) {
                    this.$emit('click');
                }
            },
        },
    };
</script>
